import http from 'hub-http/clients/apiClient';
import { useQuery, registerQuery } from 'data-fetching-client';
import { useCampaignsContext } from '../CampaignsProvider';
import { SENTRY_KEYS } from 'campaigns-lib/constants/sentry';
import Raven from 'raven-js';
export const GET_ASSOCIATED_CAMPAIGN_FIELD_NAME = 'campaignsPlatformComponentsAssociatedCampaign';
const MAX_CAMPAIGNS_ASSOCIATIONS_TO_FETCH = 500;
const GET_ASSOCIATED_CAMPAIGNS = registerQuery({
  fieldName: GET_ASSOCIATED_CAMPAIGN_FIELD_NAME,
  args: ['objectType', 'objectId', 'associationSettings', 'isOneToMany', 'isFetchingAllObjectProperties', 'editCampaignObjectId'],
  fetcher({
    objectType,
    objectId,
    associationSettings,
    isOneToMany,
    isFetchingAllObjectProperties,
    editCampaignObjectId
  }) {
    const objectSettings = associationSettings[objectType].campaignsAssociations.metadata;

    // You can explore the output at https://tools.hubteamqa.com/api/request/7184cd17b44047a38540e17cdbc03b3e
    return http.post(`/crm-search/search`, {
      data: {
        count: isOneToMany ? MAX_CAMPAIGNS_ASSOCIATIONS_TO_FETCH : 1,
        objectTypeId: '0-35',
        fetchSource: false,
        fetchVersion: false,
        requestOptions: Object.assign({
          includeObjectVersion: false
        }, isFetchingAllObjectProperties ? {
          includeAllValues: true
        } : {
          includeAllValues: false,
          properties: ['hs_origin_asset_id', 'hs_name']
        }),
        filterGroups: [{
          filters: [editCampaignObjectId ? {
            operator: 'EQ',
            property: 'hs_object_id',
            value: editCampaignObjectId
          } : {
            operator: 'EQ',
            property: `associations.0-${objectSettings.inverseAssociationId.value}`,
            value: objectId
          }]
        }]
      }
    }).then(response => response.results || []);
  }
});
export function useFetchAssociatedCampaigns({
  objectType,
  objectId,
  associationSettings,
  isOneToMany,
  isFetchingAllObjectProperties,
  editCampaignObjectId,
  skip
}) {
  var _queryResult$data;
  const {
    setInitialCampaigns
  } = useCampaignsContext();
  const queryResult = useQuery(GET_ASSOCIATED_CAMPAIGNS, {
    variables: {
      objectType,
      objectId: objectId,
      associationSettings: associationSettings,
      isOneToMany,
      isFetchingAllObjectProperties,
      editCampaignObjectId
    },
    onError: error => Raven.captureException(error, {
      fingerprint: [SENTRY_KEYS.FRAMEWORK_APP_SETTINGS_FETCH_FAILED],
      tags: {
        lib: 'campaigns-lib'
      }
    }),
    onCompleted: completedData => {
      const initialCampaigns = completedData === null || completedData === void 0 ? void 0 : completedData[GET_ASSOCIATED_CAMPAIGN_FIELD_NAME];

      // Save the initial campaign to the context to be saved outside of the select.
      setInitialCampaigns(initialCampaigns.map(campaign => ({
        campaignGuid: campaign.properties.hs_origin_asset_id.value,
        objectId: campaign.objectId
      })));
    },
    skip: !objectId || !(associationSettings !== null && associationSettings !== void 0 && associationSettings[objectType]) || skip
  });
  return {
    data: (_queryResult$data = queryResult.data) === null || _queryResult$data === void 0 ? void 0 : _queryResult$data[GET_ASSOCIATED_CAMPAIGN_FIELD_NAME],
    loading: queryResult.loading,
    error: queryResult.error,
    refetch: queryResult.refetch
  };
}